<template>

    <div class="container gatwayBg">
        <div class="table table-container">
            <el-table  :height="'calc('+(tableHeight)+'px)'" border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
                <el-table-column width="80" type="index" align="center" label="序号">
                    <template #default="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
              
                <el-table-column min-width="110" prop="ip" label="IP" align="center"></el-table-column>
                <el-table-column min-width="150" prop="sn" label="网关ID" align="center"></el-table-column>
                <el-table-column min-width="60" prop="online" label="网关状态" align="center"></el-table-column>
                <el-table-column min-width="120" prop="latest_online_time" label="最新在线时间" align="center"></el-table-column>
                
             
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        
    </div>
</template>
<script> 
    import {apigatewayConfigure} from '@/api/api'
    import Pagination from "@/components/Pagination";
    import deviceTypeConfig from "@/config"
    export default {
        components:{
            Pagination,
        },
        name:'gatewayConfigure',
        data() {
            return {
                isFull:false,
                tableHeight:500,
                loadingPage:false,
                formInline:{
                    page: 1,
                    page_size: 10,
                    level: null,
                    sensor_name: null,
                    sensor_sn: null,
                    id:null,
                },
                pageparm: {
                    page: 1,
                    page_size: 10,
                    total: 0
                },
                tableData:[],
                timers:[],
                fnParm:{
                    page: 1,
                    page_size: 10,  
                
                    ordering:"processed,-time",         
                },
            }
        },
        methods:{
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.page_size + $index +1
            },

          
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.page_size = parm.page_size
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.page_size = 10

                this.getData()
            },
            formatDate(date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
            //获取列表
            dataChange(items){
                this.tableData.length = 0
                for(let i = 0;i<items.length;i++){
                    this.tableData[i] = items[i]
                    switch(items[i].online){
                        case true:  this.tableData[i].online="在线" ;break;
                        case false:  this.tableData[i].online="离线";break;
                        default: this.tableData[i].online="未知" ;break;
                    }
                   
                   
                }       
            },


            getData(){
                this.loadingPage = true
                this.tableData.length = 0;
           

                apigatewayConfigure(this.fnParm).then(res => {
                    this.loadingPage = false
                  
                    
                    if(res.data.code ==200) {
                        this.dataChange(res.data.data.items)
                        this.pageparm.total = res.data.data.total;
                        let { page, page_size } = res.config.params 
                        this.pageparm.page = page    
                        this.pageparm.page_size = page_size  
                    }else{
                        this.$message.error(res.data.msg)
                    }
             
                }
           
                
                ) .catch(res => {  
                    this.loadingPage = false
                    this.tableData.length = 0
                    this.$message.warning(`获取传感器信息失败 : ${res.msg}`)
                });  
            }, 
           
         
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
            //    this.tableHeight = (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 178

               var bg_padding = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--my-css-var-bg-padding'));
               this.tableHeight =  (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 178 - 2*bg_padding

            }
        },
        created() {
            this.getData()
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },
        unmounted() {
              // 页面销毁，去掉监听事件
            window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss" scoped>
    .tableNav{
        overflow: hidden;
        margin-bottom: 20px;
    }

    // .container {
    // display: flex;
    // flex-direction: column;
    // height: 100vh; /* 设置容器占据整个浏览器高度 */
    // }

    .table-container {
        flex-grow: 1; /* 占据剩余高度 */
        overflow-y: auto; /* 添加滚动条以处理溢出内容 */
    }


    .gatwayBg{
      background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      padding: var(--my-css-var-bg-padding);
    }
    
</style>



